import lodable from '@loadable/component';
import { lazy } from 'react';
import { ENV_MODE_DEV, ENV_MODE_PROD } from 'lib/setting';
import About from './about/About';
import User from './user/User';
import Home from './home/Home';
import Error from './error/Error';
import Auth from './auth/Auth';
import CodeRegistration from './auth/CodeRegistration';
import Dashboard from './dashboard/Dashboard';
import Project from './project/Project';
import Store from './store/Store';
import Account from './account/Account';
import Partner from './partner/Partner';
import Support from './support/Support';
import Invoice from './invoice/Invoice';
import Notifications from './notifications/Notifications';
import Payment from './payment/Payment';
import Kpi from './kpi/Kpi';
import Patient from './patient/Patient';
import Util from './util/Util';
import Recording from './recording/Recording';

// NOTE: test용
export const Counter = lodable(() => import('./test/__test__/Counter'));
export const TodoApp = lodable(() => import('./test/__test__/todo/TodoApp'));
export const DelayedToggle = lodable(() => import('./test/__test__/DelayedToggle'));
export const UserProfile = lodable(() => import('./test/__test__/UserProfile'));
export const Test = lodable(() => import('./test/Test'));
export const TestList = lodable(() => import('./test/TestList'));
export const TestDetail = lodable(() => import('./test/TestDetail'));

// export { default as Home } from './home/Home';
// export { default as Error } from './error/Error';
// export { default as Auth } from './auth/Auth';
// export { default as About } from './about/About';
// export { default as User } from './user/User';

// if (ENV_MODE_PROD) {
// const About = lazy(() => import('./about/About'));
// const User = lazy(() => import('./user/User'));
// const Home = lazy(() => import('./home/Home'));
// const Error = lazy(() => import('./error/Error'));
// const Auth = lazy(() => import('./auth/Auth'));
// const Jun = lazy(() => import('./jun/Jun'));
// const Dashboard = lazy(() => import('./dashboard/Dashboard'));
// const CodeRegistration = lazy(() => import('./auth/CodeRegistration'));
// const Project = lazy(() => import('./project/Project'));
// const Store = lazy(() => import('./store/Store'));
// const Account = lazy(() => import('./account/Account'));
// const Partner = lazy(() => import('./partner/Partner'));
// const Support = lazy(() => import('./support/Support'));
// const Invoice = lazy(() => import('./invoice/Invoice'));
// const Notifications = lazy(() => import('./notifications/Notifications'));
// const Payment = lazy(() => import('./payment/Payment'));
// const Kpi = lazy(() => import('./kpi/Kpi'));
// }

export {
  About,
  Home,
  Error,
  Auth,
  CodeRegistration,
  User,
  Dashboard,
  Project,
  Store,
  Account,
  Partner,
  Support,
  Invoice,
  Notifications,
  Payment,
  Kpi,
  Patient,
  Util,
  Recording,
};
